'use client'

import { useRef } from 'react'

import type { GroundData } from '@/app/_components/ground/load-ground-data'
import { SpecimenFrame } from '@/app/_components/ground/specimen-frame'
import { AnswerInput, GlyphAnchor, ProgressStrip } from '@/components/practice'
import { MarginaliaTop } from '@/learn/kanji/test/[batch]/_components/marginalia-top'

// eslint-disable-next-line @typescript-eslint/no-empty-function -- AnswerInput is controlled and requires setAnswer; the inert specimen takes its answer from the scroll, never from typing
const noop = () => {}

// Beat 04: the batch test — 四 shown, "four" typed as the scroll advances
// (`typed` = characters shown). TestFrame holds the quiz in a hook; its
// leaves take the state as props.
export function TestSpecimen({
    data,
    typed,
}: {
    data: Pick<GroundData, 'lesson' | 'four'>
    typed: number
}) {
    const inputRef = useRef<HTMLInputElement | null>(null)
    const k = data.four
    return (
        <SpecimenFrame beat={4}>
            <MarginaliaTop
                lessonNumber={data.lesson.number}
                start={1}
                end={5}
            />
            <ProgressStrip answered={3} total={5} />
            {/* The focus is the glyph with its input: the camera keeps both
                in the band, or the glyph rides up behind the docked caption. */}
            <div data-focus>
                <div className="mt-6 md:mt-8">
                    <GlyphAnchor character={k.character} />
                </div>
                <div className="mt-10 flex justify-center">
                    <AnswerInput
                        answer={k.meaning.slice(0, typed)}
                        setAnswer={noop}
                        phase="answering"
                        inputRef={inputRef}
                    />
                </div>
            </div>
        </SpecimenFrame>
    )
}
